import PropTypes from 'prop-types'
import { Box, Chip } from '@mui/material'
import clsx from 'clsx'

import useTranslations from '../../../../i18n/useTranslations'
import Radio from '../../../../ui/components/radio'

import useStyles from './styles'

const propTypes = {
  addresses: PropTypes.array,
  selectedAddressId: PropTypes.string,
  selectAddress: PropTypes.func,
}

const Addresses = ({ addresses, selectedAddressId, selectAddress }) => {
  const t = useTranslations()
  const classes = useStyles()
  return (
    <Box className={classes.radiosContainer}>
      {addresses.map(address => {
        const isSelected = selectedAddressId === address.id

        return (
          <Box
            key={address.id}
            className={clsx(classes.radioWrapper, {
              'is-checked': isSelected,
            })}
          >
            <Radio
              className={classes.radio}
              label={address.name}
              subLabel={t('address:without-name', {
                address: address.shippingAddress.address,
                postalCode: address.shippingAddress.postalCode,
                city: address.shippingAddress.city,
                country: address.shippingAddress.country?.code ?? address.shippingAddress.country,
              })}
              additionalText={
                address.shippingAddress.email || address.shippingAddress.phone
                  ? `${address.shippingAddress.email || ''}${
                      address.shippingAddress.email &&
                      address.shippingAddress.phone
                        ? ', '
                        : ''
                    }${address.shippingAddress.phone || ''}`
                  : null
              }
              multiline={false}
              checked={isSelected}
              onChange={() => selectAddress(address)}
            />
            {!address.isAddressBook ? (
              <Chip
                label={t('address:contract-default')}
                className={classes.chip}
              />
            ) : null}
          </Box>
        )
      })}
    </Box>
  )
}

Addresses.propTypes = propTypes

export default Addresses
